<template>
    <div style="height:100vh;background: #FCF5EC;position: relative;">
		<div style="position: absolute;top: 12px;left: 0; width: 100%;height: 32px;display: flex;align-items: center;justify-content: center;">
			<!-- <div style="position: absolute;display: flex;align-items: center;">
				<img src="@/assets/searchs@2x.png" style="width: 13px;height: 12px;margin-right: 8px;">
				<label style="font-size: 12px;color: #9A9E9E;">搜索</label>
			</div> -->
			<input type="text" name="" id="" class="ips" v-model="searchkey" @input="search" placeholder="客户名称/序列号/产品名称搜索">
		</div>
		<div style="position: fixed;width: 92%;margin-left: 4%;top: 60px;border-radius: 8px;overflow-y: scroll;height: 83vh;" v-if="!isNull">
			<div v-for="item in hisList" :key="item.id" style="background: #fff;margin-bottom: 14px;padding: 18px 18px 0 18px;box-sizing: border-box;border-radius: 8px;">
				<div style="display: flex;">
					<div style="display: flex;flex-direction: column; align-items: center;">
						<img :src="'https://spare4.qiyasoft.top/storage/547f3ed73176918cf0b834947a508e7e1709087162.png'" style="width: 32px;height: 32px;border-radius: 50%;">
						<div style="width: 38px;height: 16px;background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);border-radius: 4px;font-size: 12px;color: #fff;text-align: center;line-height: 16px;margin-top: -8px;">客户</div>
					</div>
					<div style="margin-left: 10px;">
						<div style="font-weight: 500;font-size: 16px;color: #333333;">{{item.customerName}}</div>
						<div style="font-weight: 500;font-size: 14px;color: #9A9B9E;margin-top: 3px;">序列号：{{item.serialNumber}}</div>
					</div>
				</div>
				<div style="padding: 10px 11px;background: #F7F7F7;border-radius: 6px;margin-top: 12px;font-weight: 500;font-size: 14px;color: #4B4D4D;">
					
					<div>产品名称：{{item.productName}}</div>
					<div>产品价格：{{item.productPrice}}</div>
					<div>规格型号：{{item.specModel}}</div>
					<!-- <div>电控单元/注油机：{{item.dkzyj}}</div> -->
					<!-- <div>销售/备用：{{item.sxby}}</div> -->
					<div>出厂日期：{{formatDate1(item.ccrq)}}</div>
					<!-- <div>机器序号：{{item.xh}}</div> -->
					<!-- <div>交付日期：{{formatDate(item.deliveryDate)}}</div> -->
					<div>质保年限：{{item.warrantyDate}}</div>
					<div>客户名称：{{item.customerName}}</div>
					<div>联系电话：{{item.customerMobile}}</div>
					<div>已维修次数：{{item.maintenance.length}}</div>
					<div>备注：{{item.remarks}}</div>
				</div>
				<div style="display: flex;align-items: center;height: 44px;">
					<!-- <div style="width:50%;text-align: center; font-weight: 500;font-size: 14px;color: #9A9E9E;">取消推荐</div> -->
					<!-- <div style="width: 1px;height: 15px;background: #979797;"></div> -->
					<div style="width:100%;text-align: center;font-weight: 500;font-size: 14px;color: #333333;" @click="jzgz(item)">维修记录</div>
					<div style="height: 20px;width: 3px;background: #F7F7F7;"></div>
					<div style="width:100%;text-align: center;font-weight: 500;font-size: 14px;color: #333333;" @click="editSale(item)">修改</div>
					<div style="height: 20px;width: 3px;background: #F7F7F7;"></div>
					<div style="width:100%;text-align: center;font-weight: 500;font-size: 14px;color:red;" @click="delSale(item.id)">删除</div>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;position: fixed;background: #fff;width: 92%;height: 90vh;margin-left: 4%;top: 55px;border-radius: 8px;" v-if="isNull">
			<img src="@/assets/undraw_empty_re_opql@2x.png" style="width:217px;height: 170px;">
			<div style="font-family: PingFangSC, PingFang SC;font-style: normal;font-weight: 500;font-size: 16px;color: #333333;line-height: 26px;letter-spacing: 1px;text-align: center;display: flex;flex-direction: column; align-items: center;justify-content: center;line-height: 28px;">
				<div style="margin-top: 30px;">啊哦，空空如也~</div>
			</div>
		</div>
		<div class="share-url" @click="shareUrl">新增</div>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { user } from "@/api";
import dayjs from "dayjs";
import { effectScope } from 'vue';

export default {
  data() {
    return {
		isNull: false,
		searchkey: '',
		hisList: [],
			pdfList: []
    };
  },
	mounted() {
		document.title = "销售列表";
		this.getHisList()
	},
	methods: {
		editSale(e) {
			this.$router.push({
				path:'/add-sale',
				query: {
					sale: JSON.stringify(e)
				}
			})
		},
		delSale(e) {
			Dialog.confirm({
			title: '提醒',
			message: '确定删除该条记录吗？',
			})
			.then(() => {
				user.delSale({id: e}).then(res=>{
					if(res.data.code == 200) {
						this.$toast.success('删除成功');
						this.getHisList()
					}
				})
			})
			.catch(() => {
				// on cancel
			});
		},
		shareUrl() {
			this.$router.push({
				path:'/add-sale'
			})
		},
		goRecommend() {
			this.$router.back();
		},
		search(e) {
			console.log(e.target.value);
			this.searchkey = e.target.value;
			this.getHisList()
		},
		getHisList() {
			user.getMyHistory({page: 1,pageSize: 500, keyword: this.searchkey}).then(res => {
				if(res.data.code == 200) {
					console.log(res);
					this.hisList = res.data.data.resultList;
					if(this.hisList.length == 0) {
						this.isNull = true;
					} else {
						this.isNull = false;
					}
				}
			})
		},
		formatDate(e) {
			return dayjs(e).format('YYYY-MM-DD');
		},
		formatDate1(e) {
			let ls = '20' + e
			return dayjs(ls).format('YYYY-MM-DD');
		},
		jzgz(e) {
			this.$router.push({
				path:'/wxjl',
				query: {
					id: e.id
				}
			})
		}
	}
}
</script>
<style scoped>
::-webkit-scrollbar{
	display: none;
}
.ips{
	width: 92%;height: 32px;border: none;border-radius: 50px;padding: 0 15px;box-sizing: border-box;font-family: PingFang-SC, PingFang-SC;font-weight: 500;font-size: 12px;color: #4B4D4D;line-height: 20px;text-align: left;font-style: normal;
}
.top-bar-box {
	width: 100%;
	height: 44px;
	background: #fff;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	font-size: 15px;
	position: relative;
}
.sysc {
	width: 24px;
	height: 26px;
	position: absolute;
	right: 10px;
}
.top-bar {
	width: 100%;
	height: 44px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.top-bar-title {
	height: 41px;
	line-height: 41px;
}
.top-bar-line {
	width: 24px;
	height: 3px;
	border-radius: 10px;
}
.is-sel {
	color: #333333;
}
.no-sel {
	color: #9A9B9E;
}

.is-line-sel {
	background: #4873C0;
	animation: fadein 0.5s;
}
.no-line-sel {
	background: #fff;
	animation: fadeout 0.5s;
}
.share-url {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);
  line-height: 49px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  position: fixed;
  bottom: 10px;
  left: 0;
  cursor: pointer;
}
@keyframes fadeout {
    /*设置内容由显示变为隐藏*/
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes fadein {
    /*设置内容由隐藏变为显示*/
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
